/**
 * "Create rider" from a command (the band's Generate command, a calendar event's "Create rider for this gig") asks the
 * band page to show the Create rider dialog. Commands cannot render, so they set this and navigate to the band; the
 * band page's host takes it and clears it. Same shape as `review/review-request.ts`.
 */
export interface CreateRiderRequest {
  bandId: string
  /** The calendar event the rider is for */
  eventId?: string
}

let pending: CreateRiderRequest | undefined
const listeners = new Set<() => void>()

const notify = () => listeners.forEach(listener => listener())

export const requestCreateRider = (request: CreateRiderRequest) => {
  pending = request
  notify()
}

export const clearCreateRiderRequest = () => {
  pending = undefined
  notify()
}

export const getCreateRiderRequest = () => pending

export const subscribeCreateRiderRequest = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
